import RegionalLayout from "./RegionalLayout";
import { BarChart3 } from "lucide-react";

const crd = {
  background: "var(--surface-card)",
  border: "var(--border-width, 1px) solid var(--border-default)",
  borderRadius: "1rem",
  boxShadow: "var(--shadow-card)",
};
const tp = { color: "var(--text-primary)" };
const ts = { color: "var(--text-secondary)" };
const tm = { color: "var(--text-muted)" };

export default function SkillsLandscape() {
  return (
    <RegionalLayout>
      <div className="max-w-[1440px] mx-auto space-y-5">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight" style={tp}>Skills Landscape</h1>
          <p className="text-sm mt-0.5" style={ts}>Skills distribution, proficiency levels, and capability analysis</p>
        </div>
        <div className="p-12 flex flex-col items-center text-center" style={crd} data-testid="skills-coming-soon">
          <div className="w-16 h-16 rounded-full flex items-center justify-center mb-4" style={{ background: "var(--color-accent-bg, rgba(0,174,239,0.08))" }}>
            <BarChart3 className="w-8 h-8" style={{ color: "#00AEEF" }} />
          </div>
          <p className="text-lg font-semibold" style={tp}>Coming Soon</p>
          <p className="text-sm mt-2 max-w-md" style={ts}>
            Skills distribution by domain, proficiency vs industry benchmarks, top strengths and gaps,
            and career aspiration themes from the Self-Assessment Framework.
          </p>
          <div className="flex gap-2 mt-5">
            {["Cloud", "Security", "Data/AI", "DevOps", "Infrastructure", "Core Dev"].map(d => (
              <span key={d} className="text-[10px] px-2.5 py-1 rounded-full font-medium"
                style={{ background: "var(--surface-inner)", color: "var(--text-secondary)" }}>{d}</span>
            ))}
          </div>
        </div>
      </div>
    </RegionalLayout>
  );
}
